import axios from 'axios'
import {
  validateGuardCanPerformActions,
  validateCanStartShift,
  hasExceededMaxShiftDuration,
  MAX_SHIFT_DURATION_MS
} from '@/services/shiftValidationService'

const API_BASE_URL = 'https://empresa-service.intrare.app'

// Claves de localStorage para persistir el estado del turno del guardia (rol 9)
// entre recargas de página, y permitir que el router bloquee la app sincrónicamente
// sin esperar la respuesta del API.
const GUARD_SHIFT_STARTED_KEY = 'guard_shift_started'
const GUARD_ACTIVE_SHIFT_KEY = 'guard_active_shift'

function getStoredActiveShift() {
  try {
    const raw = localStorage.getItem(GUARD_ACTIVE_SHIFT_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

function persistActiveShift(shift) {
  if (shift) {
    localStorage.setItem(GUARD_SHIFT_STARTED_KEY, 'true')
    localStorage.setItem(GUARD_ACTIVE_SHIFT_KEY, JSON.stringify(shift))
  } else {
    localStorage.removeItem(GUARD_SHIFT_STARTED_KEY)
    localStorage.removeItem(GUARD_ACTIVE_SHIFT_KEY)
  }
}

// Action types
export const FETCH_AVAILABLE_COMPANIES = 'FETCH_AVAILABLE_COMPANIES'
export const LINK_COMPANY = 'LINK_COMPANY'
export const DELETE_LINK = 'DELETE_LINK'
export const FETCH_CONTRACT = 'FETCH_CONTRACT'
export const INVITE_SECURITY_ADMIN = 'INVITE_SECURITY_ADMIN'
export const FETCH_MY_COMPANY = 'FETCH_MY_COMPANY'
export const FETCH_ADMIN_DASHBOARD = 'FETCH_ADMIN_DASHBOARD'
export const FETCH_GUARDS = 'FETCH_GUARDS'
export const CREATE_GUARD = 'CREATE_GUARD'
export const FETCH_GUARD_DETAIL = 'FETCH_GUARD_DETAIL'
export const UPDATE_GUARD = 'UPDATE_GUARD'
export const ASSIGN_GUARD = 'ASSIGN_GUARD'
export const DELETE_GUARD = 'DELETE_GUARD'
export const FETCH_ACTIVE_SHIFTS = 'FETCH_ACTIVE_SHIFTS'
export const START_SHIFT = 'START_SHIFT'
export const END_SHIFT = 'END_SHIFT'
export const FETCH_ACTIVE_SHIFT = 'FETCH_ACTIVE_SHIFT'
export const DEACTIVATE_ACTIVE_SHIFT = 'DEACTIVATE_ACTIVE_SHIFT'
export const FETCH_MY_CASETAS = 'FETCH_MY_CASETAS'
export const FETCH_PENDING_CONTRACTS = 'FETCH_PENDING_CONTRACTS'
export const RESPOND_TO_CONTRACT = 'RESPOND_TO_CONTRACT'
export const LINK_PARK = 'LINK_PARK'
export const FETCH_MY_PARKS = 'FETCH_MY_PARKS'
export const UNLINK_PARK = 'UNLINK_PARK'
export const RESPOND_TO_PARK_CONTRACT = 'RESPOND_TO_PARK_CONTRACT'
export const ASSIGN_GUARD_TO_PARK = 'ASSIGN_GUARD_TO_PARK'
export const FETCH_GEOCERCAS = 'FETCH_GEOCERCAS'
export const FETCH_GUARD_GEOCERCAS = 'FETCH_GUARD_GEOCERCAS'
export const CREATE_GEOCERCA = 'CREATE_GEOCERCA'
export const UPDATE_GEOCERCA = 'UPDATE_GEOCERCA'
export const DELETE_GEOCERCA = 'DELETE_GEOCERCA'
export const FETCH_GEOCERCA_DETAIL = 'FETCH_GEOCERCA_DETAIL'
export const CREATE_CHECKPOINT = 'CREATE_CHECKPOINT'
export const START_ROUND = 'START_ROUND'
export const FETCH_ACTIVE_ROUND = 'FETCH_ACTIVE_ROUND'
export const REGISTER_CHECKPOINT_VISIT = 'REGISTER_CHECKPOINT_VISIT'
export const COMPLETE_ROUND = 'COMPLETE_ROUND'
export const FETCH_ROUND_DETAIL = 'FETCH_ROUND_DETAIL'
export const FETCH_ROUNDS_HISTORY = 'FETCH_ROUNDS_HISTORY'
export const VALIDATE_SHIFT_STATUS = 'VALIDATE_SHIFT_STATUS'
export const AUTO_LOGOUT_ON_MAX_SHIFT = 'AUTO_LOGOUT_ON_MAX_SHIFT'
export const FETCH_DOCUMENT_REQUESTS = 'FETCH_DOCUMENT_REQUESTS'
export const CREATE_DOCUMENT_REQUEST = 'CREATE_DOCUMENT_REQUEST'
export const FETCH_DOCUMENT_REQUEST_DETAIL = 'FETCH_DOCUMENT_REQUEST_DETAIL'
export const FETCH_MY_DOCUMENT_REQUESTS = 'FETCH_MY_DOCUMENT_REQUESTS'
export const SUBMIT_DOCUMENT = 'SUBMIT_DOCUMENT'
export const APPROVE_DOCUMENT_SUBMISSION = 'APPROVE_DOCUMENT_SUBMISSION'
export const REJECT_DOCUMENT_SUBMISSION = 'REJECT_DOCUMENT_SUBMISSION'
export const FETCH_SECURITY_MESSAGES = 'FETCH_SECURITY_MESSAGES'
export const CREATE_SECURITY_MESSAGE = 'CREATE_SECURITY_MESSAGE'
export const FETCH_MESSAGE_REPORT = 'FETCH_MESSAGE_REPORT'
export const FETCH_MY_MESSAGES = 'FETCH_MY_MESSAGES'
export const MARK_MESSAGE_AS_READ = 'MARK_MESSAGE_AS_READ'
export const SET_AVAILABLE_COMPANIES = 'SET_AVAILABLE_COMPANIES'
export const SET_CONTRACT = 'SET_CONTRACT'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const SET_MY_COMPANY = 'SET_MY_COMPANY'
export const SET_ADMIN_DASHBOARD = 'SET_ADMIN_DASHBOARD'
export const SET_GUARDS = 'SET_GUARDS'
export const SET_GUARD_DETAIL = 'SET_GUARD_DETAIL'
export const SET_ACTIVE_SHIFTS = 'SET_ACTIVE_SHIFTS'
export const SET_ACTIVE_SHIFT = 'SET_ACTIVE_SHIFT'
export const SET_MY_CASETAS = 'SET_MY_CASETAS'
export const SET_PENDING_CONTRACTS = 'SET_PENDING_CONTRACTS'
export const SET_MY_PARKS = 'SET_MY_PARKS'
export const SET_PARK_DETAIL = 'SET_PARK_DETAIL'
export const SET_GEOCERCAS = 'SET_GEOCERCAS'
export const SET_GUARD_GEOCERCAS = 'SET_GUARD_GEOCERCAS'
export const ADD_GEOCERCA = 'ADD_GEOCERCA'
export const REPLACE_GEOCERCA = 'REPLACE_GEOCERCA'
export const REMOVE_GEOCERCA = 'REMOVE_GEOCERCA'
export const SET_GEOCERCA_DETAIL = 'SET_GEOCERCA_DETAIL'
export const SET_ACTIVE_ROUND = 'SET_ACTIVE_ROUND'
export const SET_ROUND_DETAIL = 'SET_ROUND_DETAIL'
export const SET_ROUNDS_HISTORY = 'SET_ROUNDS_HISTORY'
export const SET_DOCUMENT_REQUESTS = 'SET_DOCUMENT_REQUESTS'
export const SET_DOCUMENT_REQUEST_DETAIL = 'SET_DOCUMENT_REQUEST_DETAIL'
export const SET_MY_DOCUMENT_REQUESTS = 'SET_MY_DOCUMENT_REQUESTS'
export const SET_SECURITY_MESSAGES = 'SET_SECURITY_MESSAGES'
export const SET_MESSAGE_REPORT = 'SET_MESSAGE_REPORT'
export const SET_MY_MESSAGES = 'SET_MY_MESSAGES'

// Store module
const state = {
  contract: null,
  availableCompanies: [],
  loading: false,
  error: null,
  status: '',
  myCompany: null,
  adminDashboard: null,
  guards: [],
  guardDetail: null,
  activeShifts: [],
  activeShift: getStoredActiveShift(),
  myCasetas: null,
  pendingContracts: [],
  myParks: [],
  parkDetail: null,
  geocercas: [],
  guardGeocercas: [],
  geocercaDetail: null,
  activeRound: null,
  roundDetail: null,
  roundsHistory: [],
  documentRequests: [],
  documentRequestDetail: null,
  myDocumentRequests: [],
  securityMessages: [],
  messageReport: null,
  myMessages: [],
  shiftValidation: {
    canPerformActions: true,
    message: '',
    timeExceeded: false,
    shouldAutoLogout: false
  },
  shiftCheckInterval: null
}

const getters = {
  getContract: state => {
    if (!state.contract) return null;
    if (state.contract.contract) {
      return {
        ...state.contract.contract,
        pending_invitation: state.contract.pending_invitation
      };
    }
    return state.contract;
  },
  getAvailableCompanies: state => {
    if (!state.availableCompanies) return [];
    if (state.availableCompanies.available_security_companies) {
      return state.availableCompanies.available_security_companies;
    }
    return Array.isArray(state.availableCompanies) ? state.availableCompanies : [];
  },
  isSecurityLoading: state => state.loading,
  getSecurityError: state => state.error,
  hasActiveContract: state => {
    if (!state.contract) return false;
    const contractData = state.contract.contract || state.contract;
    return contractData.is_active === true;
  },
  hasAnyContract: state => {
    // Returns true if there's any contract that is not REJECTED or INACTIVE
    // Blocks new invitations/links while contract is PENDING or ACTIVE
    if (!state.contract) return false;
    const contractData = state.contract.contract || state.contract;
    if (!contractData || !contractData.status) return false;
    const status = contractData.status;
    return status !== 'REJECTED' && status !== 'INACTIVE' && status !== null;
  },
  hasPendingInvitation: state => {
    return !!(state.contract && state.contract.pending_invitation);
  },
  getPendingInvitation: state => {
    return (state.contract && state.contract.pending_invitation) || null;
  },
  getSecurityStatus: state => state.status,
  getMyCompany: state => state.myCompany,
  getAdminDashboard: state => state.adminDashboard,
  getGuards: state => state.guards,
  getGuardDetail: state => state.guardDetail,
  getActiveShifts: state => state.activeShifts,
  getActiveShift: state => state.activeShift,
  hasGuardStartedShift: state => localStorage.getItem(GUARD_SHIFT_STARTED_KEY) === 'true' && !!state.activeShift,
  getMyCasetas: state => state.myCasetas,
  getPendingContracts: state => state.pendingContracts,
  getMyParks: state => state.myParks,
  getParkDetail: state => state.parkDetail,
  getGeocercas: state => state.geocercas,
  getGuardGeocercas: state => state.guardGeocercas,
  getGeocercaDetail: state => state.geocercaDetail,
  getActiveRound: state => state.activeRound,
  getRoundDetail: state => state.roundDetail,
  getRoundsHistory: state => state.roundsHistory,
  getDocumentRequests: state => state.documentRequests,
  getDocumentRequestDetail: state => state.documentRequestDetail,
  getMyDocumentRequests: state => state.myDocumentRequests,
  getSecurityMessages: state => state.securityMessages,
  getMessageReport: state => state.messageReport,
  getMyMessages: state => state.myMessages,
  getShiftValidation: state => state.shiftValidation,
  canGuardPerformActions: state => state.shiftValidation.canPerformActions,
  shouldAutoLogout: state => state.shiftValidation.shouldAutoLogout
}

const actions = {
  [FETCH_AVAILABLE_COMPANIES]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/available-companies/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_AVAILABLE_COMPANIES, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching available companies')
          reject(err)
        })
    })
  },

  [LINK_COMPANY]: ({ commit }, { token, securityCompanyId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/link-company/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          security_company_id: securityCompanyId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_CONTRACT, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching available companies')
          reject(err)
        })
    })
  },

  [DELETE_LINK]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'delete',
        url: `${API_BASE_URL}/security/link-company/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_CONTRACT, null)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
                    commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error unlinking security company')
          reject(err)
        })
    })
  },

  [FETCH_CONTRACT]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-contract/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_CONTRACT, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_CONTRACT, null)
          commit(SET_LOADING, false)
          // No error for 404 - it just means no active contract
          resolve(null)
        })
    })
  },

  [INVITE_SECURITY_ADMIN]: ({ commit }, { token, email, firstName, lastName }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/invite-security-admin/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          email,
          first_name: firstName,
          last_name: lastName
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error inviting security admin')
          reject(err)
        })
    })
  },

  [FETCH_MY_COMPANY]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-company/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_MY_COMPANY, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching company info')
          reject(err)
        })
    })
  },

  [FETCH_ADMIN_DASHBOARD]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/dashboard/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ADMIN_DASHBOARD, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching dashboard')
          reject(err)
        })
    })
  },

  [FETCH_GUARDS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/guards/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_GUARDS, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching guards')
          reject(err)
        })
    })
  },

  [CREATE_GUARD]: ({ commit }, {
    token,
    firstName,
    lastName,
    password,
    avatar,
    ine,
    ineReverso,
    responsibilityFormat,
    sua
  }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      const formData = new FormData()
      formData.append('first_name', firstName)
      formData.append('last_name', lastName)
      formData.append('password', password)
      formData.append('ine', ine)
      formData.append('ine_reverso', ineReverso)
      formData.append('responsibility_format', responsibilityFormat)
      if (avatar) formData.append('avatar', avatar)
      if (sua) formData.append('sua', sua)

      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/guards/`,
        headers: {
          'authorization': `Token ${token}`
        },
        data: formData
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error creating guard')
          reject(err)
        })
    })
  },

  [FETCH_GUARD_DETAIL]: ({ commit }, { token, guardId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_GUARD_DETAIL, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching guard details')
          reject(err)
        })
    })
  },

  [UPDATE_GUARD]: ({ commit }, { token, guardId, firstName, lastName, password, avatar, isActive, assignedCompanyId, ine, sua, responsibilityFormat }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      const formData = new FormData()
      if (firstName !== undefined) formData.append('first_name', firstName)
      if (lastName !== undefined) formData.append('last_name', lastName)
      if (password) formData.append('password', password)
      if (avatar !== undefined && avatar !== null) formData.append('avatar', avatar)
      if (isActive !== undefined) formData.append('is_active', isActive ? 'true' : 'false')
      if (assignedCompanyId !== undefined) formData.append('assigned_company', assignedCompanyId)
      if (ine !== undefined && ine !== null) formData.append('ine', ine)
      if (sua !== undefined && sua !== null) formData.append('sua', sua)
      if (responsibilityFormat !== undefined && responsibilityFormat !== null) formData.append('responsibility_format', responsibilityFormat)

      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': `Token ${token}`
        },
        data: formData
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error updating guard')
          reject(err)
        })
    })
  },

  [ASSIGN_GUARD]: ({ commit }, { token, guardId, assignedCompanyId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)

      const normalizedAssignedCompanyId = assignedCompanyId === undefined ? null : assignedCompanyId

      const requestConfig = payload => ({
        method: 'patch',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: payload
      })

      // Prefer assigned_company_id (current contract docs); fallback to assigned_company for legacy serializers.
      axios(requestConfig({ assigned_company_id: normalizedAssignedCompanyId }))
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          const hasResponseError = err && err.response && err.response.status >= 400 && err.response.status < 500
          if (!hasResponseError) {
            commit(SET_LOADING, false)
            commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error assigning guard')
            reject(err)
            return
          }

          axios(requestConfig({ assigned_company: normalizedAssignedCompanyId }))
            .then(resp => {
              commit(SET_LOADING, false)
              resolve(resp.data)
            })
            .catch(err2 => {
              commit(SET_LOADING, false)
              commit(SET_ERROR, (err2.response && err2.response.data && err2.response.data.detail) || 'Error assigning guard')
              reject(err2)
            })
        })
    })
  },

  [DELETE_GUARD]: ({ commit }, { token, guardId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'delete',
        url: `${API_BASE_URL}/security/guards/${guardId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error deleting guard')
          reject(err)
        })
    })
  },

  [FETCH_ACTIVE_SHIFTS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/shifts/all-active/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const shiftsData = Array.isArray(resp.data) ? resp.data : (resp.data.results || [])
          const normalizedShifts = shiftsData.map(shift => ({
            ...shift,
            company_name: shift.company_name || shift.assigned_company_name || 'N/A',
            location: shift.location || shift.caseta_name || '-',
            end_time: shift.end_time || null,
            is_active: shift.is_active === undefined ? true : shift.is_active
          }))

          commit(SET_ACTIVE_SHIFTS, normalizedShifts)
          commit(SET_LOADING, false)
          resolve(normalizedShifts)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching shifts')
          reject(err)
        })
    })
  },

  [START_SHIFT]: ({ commit }, { token, casetaId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const data = {}
      if (casetaId) data.caseta_id = casetaId

      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/shifts/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: data
      }
      axios(config)
        .then(resp => {
          // Persistir el turno en el store (y localStorage vía la mutation) para
          // que el sidemenu y el guard global del router se desbloqueen de inmediato.
          commit(SET_ACTIVE_SHIFT, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error starting shift')
          reject(err)
        })
    })
  },

  [END_SHIFT]: ({ commit }, { token, shiftId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/shifts/${shiftId}/end/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error ending shift')
          reject(err)
        })
    })
  },

  [FETCH_MY_CASETAS]: ({ commit, rootGetters }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      
      // Determinar el endpoint según el roll del usuario
      const userProfile = rootGetters.getProfile
      let endpoint = `${API_BASE_URL}/empresas/casetas/` // Default para legacy (roll 2)
      
      // Si es guardia Z (roll 9), usar el endpoint de security
      if (userProfile && userProfile.roll === 9) {
        endpoint = `${API_BASE_URL}/security/my-casetas/`
      }
      
      const config = {
        method: 'get',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_MY_CASETAS, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching casetas')
          reject(err)
        })
    })
  },

  [FETCH_PENDING_CONTRACTS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/pending-contracts/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          // Extraer pending_requests del objeto respuesta
          const pendingRequests = resp.data.pending_requests || []
          commit(SET_PENDING_CONTRACTS, pendingRequests)
          commit(SET_LOADING, false)
          resolve(pendingRequests)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching pending contracts')
          reject(err)
        })
    })
  },

  [RESPOND_TO_CONTRACT]: ({ commit }, { token, contractId, action }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/contract/${contractId}/respond/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          action: action
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error responding to contract')
          reject(err)
        })
    })
  },

  [FETCH_ACTIVE_SHIFT]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/shifts/active/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const activeShift = resp.data.active_shift
          commit(SET_ACTIVE_SHIFT, activeShift)
          commit(SET_LOADING, false)
          resolve(activeShift)
        })
        .catch(err => {
          commit(SET_ACTIVE_SHIFT, null)
          commit(SET_LOADING, false)
          // No error para 404 - solo significa que no hay turno activo
          resolve(null)
        })
    })
  },

  [DEACTIVATE_ACTIVE_SHIFT]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/shifts/active/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ACTIVE_SHIFT, null)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error deactivating shift')
          reject(err)
        })
    })
  },

  [LINK_PARK]: ({ commit }, { token, parkId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/link-park/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          park_id: parkId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error linking park')
          reject(err)
        })
    })
  },

  [FETCH_MY_PARKS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-parks/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          // Respuesta: { security_company, total_parks, parks: [...] }
          const parks = resp.data.parks || resp.data.results || resp.data
          commit(SET_MY_PARKS, parks)
          commit(SET_LOADING, false)
          resolve(parks)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching parks')
          reject(err)
        })
    })
  },

  [UNLINK_PARK]: ({ commit }, { token, parkId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'delete',
        url: `${API_BASE_URL}/security/link-park/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        params: {
          park_id: parkId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error unlinking park')
          reject(err)
        })
    })
  },

  [RESPOND_TO_PARK_CONTRACT]: ({ commit }, { token, contractId, action }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/contract-park/${contractId}/respond/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          action: action
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error responding to park contract')
          reject(err)
        })
    })
  },

  [ASSIGN_GUARD_TO_PARK]: ({ commit }, { token, guardId, parkId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/guards/${guardId}/assign-park/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          assigned_park_id: parkId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error assigning guard to park')
          reject(err)
        })
    })
  },

  [FETCH_GEOCERCAS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/geocercas/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const geocercas = Array.isArray(resp.data) ? resp.data : (resp.data.results || [])
          commit(SET_GEOCERCAS, geocercas)
          commit(SET_LOADING, false)
          resolve(geocercas)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching geocercas')
          reject(err)
        })
    })
  },

  [FETCH_GUARD_GEOCERCAS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/guard/geocercas/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const geocercas = Array.isArray(resp.data) ? resp.data : (resp.data.results || [])
          commit(SET_GUARD_GEOCERCAS, geocercas)
          commit(SET_LOADING, false)
          resolve(geocercas)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching guard geocercas')
          reject(err)
        })
    })
  },

  [CREATE_GEOCERCA]: ({ commit }, { token, nombre, coordenadas, descripcion }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/geocercas/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          nombre,
          coordenadas,
          descripcion: descripcion || ''
        }
      }
      axios(config)
        .then(resp => {
          commit(ADD_GEOCERCA, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error creating geocerca')
          reject(err)
        })
    })
  },

  [UPDATE_GEOCERCA]: ({ commit }, { token, geocercaId, nombre, coordenadas, descripcion, isActive }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)

      const data = {}
      if (nombre !== undefined) data.nombre = nombre
      if (coordenadas !== undefined) data.coordenadas = coordenadas
      if (descripcion !== undefined) data.descripcion = descripcion
      if (isActive !== undefined) data.is_active = isActive

      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/geocercas/${geocercaId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data
      }
      axios(config)
        .then(resp => {
          commit(REPLACE_GEOCERCA, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error updating geocerca')
          reject(err)
        })
    })
  },

  [DELETE_GEOCERCA]: ({ commit }, { token, geocercaId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'delete',
        url: `${API_BASE_URL}/security/geocercas/${geocercaId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(REMOVE_GEOCERCA, geocercaId)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error deleting geocerca')
          reject(err)
        })
    })
  },

  [FETCH_GEOCERCA_DETAIL]: ({ commit }, { token, geocercaId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/geocercas/${geocercaId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_GEOCERCA_DETAIL, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error fetching geocerca')
          reject(err)
        })
    })
  },

  [CREATE_CHECKPOINT]: ({ commit }, { token, nombre, descripcion, latitude, longitude, radioMetros, geocercaId, orden }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/checkpoints/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          nombre,
          descripcion: descripcion || '',
          latitude,
          longitude,
          radio_metros: radioMetros,
          geocerca_id: geocercaId,
          orden
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error creating checkpoint')
          reject(err)
        })
    })
  },

  [START_ROUND]: ({ commit }, { token, geocercaId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/rondines/rounds/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          geocerca_id: geocercaId
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ACTIVE_ROUND, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error starting round')
          reject(err)
        })
    })
  },

  [FETCH_ACTIVE_ROUND]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/rondines/rounds/active/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ACTIVE_ROUND, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_ACTIVE_ROUND, null)
          commit(SET_LOADING, false)
          // 404/400 solo significa que no hay ronda activa, no es un error a mostrar
          resolve(null)
        })
    })
  },

  [REGISTER_CHECKPOINT_VISIT]: ({ commit }, { token, roundId, checkpointId, latitude, longitude, foto, notas }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)

      const formData = new FormData()
      formData.append('latitude', latitude)
      formData.append('longitude', longitude)
      formData.append('foto', foto)
      if (notas) formData.append('notas', notas)

      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/rondines/rounds/${roundId}/checkpoint/${checkpointId}/`,
        headers: {
          'authorization': `Token ${token}`
        },
        data: formData
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error registering checkpoint visit')
          reject(err)
        })
    })
  },

  [COMPLETE_ROUND]: ({ commit }, { token, roundId, notas }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/rondines/rounds/${roundId}/complete/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          notas: notas || ''
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ACTIVE_ROUND, null)
          commit(SET_ROUND_DETAIL, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error completing round')
          reject(err)
        })
    })
  },

  [FETCH_ROUND_DETAIL]: ({ commit }, { token, roundId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/rondines/rounds/${roundId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_ROUND_DETAIL, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error fetching round detail')
          reject(err)
        })
    })
  },

  [FETCH_ROUNDS_HISTORY]: ({ commit }, { token, limit, offset }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/rondines/rounds/history/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        params: {
          limit: limit || 10,
          offset: offset || 0
        }
      }
      axios(config)
        .then(resp => {
          const rondas = Array.isArray(resp.data) ? resp.data : (resp.data.rondas || resp.data.results || [])
          commit(SET_ROUNDS_HISTORY, rondas)
          commit(SET_LOADING, false)
          resolve(rondas)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && (err.response.data.error || err.response.data.detail)) || 'Error fetching rounds history')
          reject(err)
        })
    })
  },

  [FETCH_DOCUMENT_REQUESTS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/document-requests/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const requests = Array.isArray(resp.data) ? resp.data : (resp.data.document_requests || resp.data.results || [])
          commit(SET_DOCUMENT_REQUESTS, requests)
          commit(SET_LOADING, false)
          resolve(requests)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching document requests')
          reject(err)
        })
    })
  },

  [CREATE_DOCUMENT_REQUEST]: ({ commit }, { token, documentType, description, deadline }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/document-requests/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          document_type: documentType,
          description: description || '',
          deadline: deadline || null
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error creating document request')
          reject(err)
        })
    })
  },

  [FETCH_DOCUMENT_REQUEST_DETAIL]: ({ commit }, { token, requestId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/document-requests/${requestId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_DOCUMENT_REQUEST_DETAIL, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching document request detail')
          reject(err)
        })
    })
  },

  [FETCH_MY_DOCUMENT_REQUESTS]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-document-requests/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const documents = Array.isArray(resp.data) ? resp.data : (resp.data.documents || resp.data.results || [])
          commit(SET_MY_DOCUMENT_REQUESTS, documents)
          commit(SET_LOADING, false)
          resolve(documents)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error fetching my document requests')
          reject(err)
        })
    })
  },

  [SUBMIT_DOCUMENT]: ({ commit }, { token, submissionId, fileUrl, fileUpload }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)

      const formData = new FormData()
      if (fileUrl) {
        formData.append('file_url', fileUrl)
      } else if (fileUpload) {
        formData.append('file_upload', fileUpload)
      }

      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/document-submissions/${submissionId}/submit/`,
        headers: {
          'authorization': `Token ${token}`
        },
        data: formData
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error submitting document')
          reject(err)
        })
    })
  },

  [APPROVE_DOCUMENT_SUBMISSION]: ({ commit }, { token, submissionId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/document-submissions/${submissionId}/approve/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error approving document')
          reject(err)
        })
    })
  },

  [REJECT_DOCUMENT_SUBMISSION]: ({ commit }, { token, submissionId, rejectionReason }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/document-submissions/${submissionId}/reject/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          rejection_reason: rejectionReason || ''
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          commit(SET_ERROR, (err.response && err.response.data && err.response.data.detail) || 'Error rejecting document')
          reject(err)
        })
    })
  },

  [FETCH_SECURITY_MESSAGES]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/messages/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const messages = Array.isArray(resp.data) ? resp.data : (resp.data.messages || resp.data.results || [])
          commit(SET_SECURITY_MESSAGES, messages)
          commit(SET_LOADING, false)
          resolve(messages)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          const errorMsg = (err.response && err.response.data && err.response.data.detail) || 'Error fetching security messages'
          commit(SET_ERROR, errorMsg)
          reject(err)
        })
    })
  },

  [CREATE_SECURITY_MESSAGE]: ({ commit }, { token, title, content, priority }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'post',
        url: `${API_BASE_URL}/security/messages/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          title,
          content,
          priority: priority || 'NORMAL'
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          const errorMsg = (err.response && err.response.data && err.response.data.detail) || 'Error creating security message'
          commit(SET_ERROR, errorMsg)
          reject(err)
        })
    })
  },

  [FETCH_MESSAGE_REPORT]: ({ commit }, { token, messageId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/messages/${messageId}/report/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_MESSAGE_REPORT, resp.data)
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          const errorMsg = (err.response && err.response.data && err.response.data.detail) || 'Error fetching message report'
          commit(SET_ERROR, errorMsg)
          reject(err)
        })
    })
  },

  [FETCH_MY_MESSAGES]: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'get',
        url: `${API_BASE_URL}/security/my-messages/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        }
      }
      axios(config)
        .then(resp => {
          const messages = Array.isArray(resp.data) ? resp.data : (resp.data.messages || resp.data.results || [])
          commit(SET_MY_MESSAGES, messages)
          commit(SET_LOADING, false)
          resolve(messages)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          const errorMsg = (err.response && err.response.data && err.response.data.detail) || 'Error fetching my messages'
          commit(SET_ERROR, errorMsg)
          reject(err)
        })
    })
  },

  [MARK_MESSAGE_AS_READ]: ({ commit }, { token, messageReadId }) => {
    return new Promise((resolve, reject) => {
      commit(SET_LOADING, true)
      commit(CLEAR_ERROR)
      const config = {
        method: 'patch',
        url: `${API_BASE_URL}/security/message-reads/${messageReadId}/`,
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Token ${token}`
        },
        data: {
          is_read: true
        }
      }
      axios(config)
        .then(resp => {
          commit(SET_LOADING, false)
          resolve(resp.data)
        })
        .catch(err => {
          commit(SET_LOADING, false)
          const errorMsg = (err.response && err.response.data && err.response.data.detail) || 'Error marking message as read'
          commit(SET_ERROR, errorMsg)
          reject(err)
        })
    })
  },

  [VALIDATE_SHIFT_STATUS]: ({ commit, state }) => {
    const validation = validateGuardCanPerformActions(state.activeShift)
    commit('SET_SHIFT_VALIDATION', validation)
    return validation
  },

  [AUTO_LOGOUT_ON_MAX_SHIFT]: ({ commit, dispatch, state }) => {
    if (!state.activeShift) return

    const checkInterval = setInterval(() => {
      if (hasExceededMaxShiftDuration(state.activeShift.start_time)) {
        clearInterval(checkInterval)
        commit('SET_SHIFT_VALIDATION', {
          canPerformActions: false,
          message: 'Tu turno ha excedido 24 horas. Tu sesión se cerrará automáticamente.',
          timeExceeded: true,
          shouldAutoLogout: true
        })
        setTimeout(() => {
          dispatch('AUTH_LOGOUT', null, { root: true })
        }, 2000)
      }
    }, 30000) // Verificar cada 30 segundos

    commit('SET_SHIFT_CHECK_INTERVAL', checkInterval)
  }
}

const mutations = {
  [SET_AVAILABLE_COMPANIES]: (state, companies) => {
    state.availableCompanies = companies
  },
  [SET_CONTRACT]: (state, contract) => {
    state.contract = contract
  },
  [SET_LOADING]: (state, loading) => {
    state.loading = loading
  },
  [SET_ERROR]: (state, error) => {
    state.error = error
    state.status = 'error'
  },
  [CLEAR_ERROR]: (state) => {
    state.error = null
    state.status = ''
  },
  [SET_MY_COMPANY]: (state, company) => {
    state.myCompany = company
  },
  [SET_ADMIN_DASHBOARD]: (state, dashboard) => {
    state.adminDashboard = dashboard
  },
  [SET_GUARDS]: (state, guards) => {
    state.guards = Array.isArray(guards) ? guards : (guards.guards || [])
  },
  [SET_GUARD_DETAIL]: (state, guard) => {
    state.guardDetail = guard
  },
  [SET_ACTIVE_SHIFTS]: (state, shifts) => {
    state.activeShifts = Array.isArray(shifts) ? shifts : (shifts.results || [])
  },
  [SET_ACTIVE_SHIFT]: (state, shift) => {
    state.activeShift = shift
    persistActiveShift(shift)
  },
  [SET_MY_CASETAS]: (state, casetas) => {
    state.myCasetas = casetas
  },
  [SET_PENDING_CONTRACTS]: (state, contracts) => {
    state.pendingContracts = Array.isArray(contracts) ? contracts : (contracts.results || [])
  },
  [SET_MY_PARKS]: (state, parks) => {
    state.myParks = Array.isArray(parks) ? parks : (parks.results || [])
  },
  [SET_PARK_DETAIL]: (state, park) => {
    state.parkDetail = park
  },
  [SET_GEOCERCAS]: (state, geocercas) => {
    state.geocercas = Array.isArray(geocercas) ? geocercas : (geocercas.results || [])
  },
  [SET_GUARD_GEOCERCAS]: (state, geocercas) => {
    state.guardGeocercas = Array.isArray(geocercas) ? geocercas : (geocercas.results || [])
  },
  [ADD_GEOCERCA]: (state, geocerca) => {
    state.geocercas = [geocerca, ...state.geocercas]
  },
  [REPLACE_GEOCERCA]: (state, geocerca) => {
    state.geocercas = state.geocercas.map(g => (g.id === geocerca.id ? geocerca : g))
  },
  [REMOVE_GEOCERCA]: (state, geocercaId) => {
    state.geocercas = state.geocercas.filter(g => g.id !== geocercaId)
  },
  [SET_GEOCERCA_DETAIL]: (state, geocerca) => {
    state.geocercaDetail = geocerca
  },
  [SET_ACTIVE_ROUND]: (state, round) => {
    state.activeRound = round
  },
  [SET_ROUND_DETAIL]: (state, round) => {
    state.roundDetail = round
  },
  [SET_ROUNDS_HISTORY]: (state, rounds) => {
    state.roundsHistory = Array.isArray(rounds) ? rounds : (rounds.results || [])
  },
  [SET_DOCUMENT_REQUESTS]: (state, requests) => {
    state.documentRequests = Array.isArray(requests) ? requests : (requests.results || [])
  },
  [SET_DOCUMENT_REQUEST_DETAIL]: (state, request) => {
    state.documentRequestDetail = request
  },
  [SET_MY_DOCUMENT_REQUESTS]: (state, documents) => {
    state.myDocumentRequests = Array.isArray(documents) ? documents : (documents.results || [])
  },
  [SET_SECURITY_MESSAGES]: (state, messages) => {
    state.securityMessages = Array.isArray(messages) ? messages : (messages.results || [])
  },
  [SET_MESSAGE_REPORT]: (state, report) => {
    state.messageReport = report
  },
  [SET_MY_MESSAGES]: (state, messages) => {
    state.myMessages = Array.isArray(messages) ? messages : (messages.results || [])
  },
  'SET_SHIFT_VALIDATION': (state, validation) => {
    state.shiftValidation = validation
  },
  'SET_SHIFT_CHECK_INTERVAL': (state, intervalId) => {
    if (state.shiftCheckInterval) {
      clearInterval(state.shiftCheckInterval)
    }
    state.shiftCheckInterval = intervalId
  },
  'CLEAR_SHIFT_CHECK_INTERVAL': (state) => {
    if (state.shiftCheckInterval) {
      clearInterval(state.shiftCheckInterval)
      state.shiftCheckInterval = null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
